// 상품상세 - 구매 안내
import format from 'date-fns/format/index.js';
import addDays from 'date-fns/fp/addDays/index.js';
import $dataStr from 'fxdom/es/dataStr.js';
import { go, html, identity, ifElse, sel } from 'fxjs/es';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopUtilConstantS } from '../../../../../Util/S/Constant/module/MShopUtilConstantS.js';
import { messages } from '../../message_id.js';
import { getFqaType, getRefundHgId, getShippingHgId } from './faq.js';
import {
  makeDeliveryInfoTable_POD_TPL,
  storesDeliveryCompanyInfo,
  takeBackInfo,
} from './storesDeliveryCompanyInfo.js';
import date_fns_tz from 'date-fns-tz';
import { UtilConstantS } from '../../../../../../Util/S/Constant/module/UtilConstantS.js';
import { MShopUtilS } from '../../../../../Util/S/Function/module/MShopUtilS.js';
import { NessCoreConstantS } from '../../../../../../Ness/Core/S/Constant/module/NessCoreConstantS.js';
import { MShopCoreTmplS } from '../../../../../Core/S/Tmpl/module/MShopCoreTmplS.js';
import { MShopCoreConstantS } from '../../../../../Core/S/Constant/module/MShopCoreConstantS.js';
import { makeEmptyScreenNavigate } from '../../../../../../../services/MarppleShop/shared/app/navigate.ts';
import { isStoreProductCustom } from '../../../../../../Creator/Product/S/fs.js';
const { utcToZonedTime } = date_fns_tz;

export const makePurchaseInfoHtml = ({ plus_crew, product_detail, store }) => {
  if (UtilS.isNessApp()) {
    if (isStoreProductCustom(product_detail._.stores_product.custom_level))
      return makePurchaseInfoHtmlNessForAssetOrUser({ plus_crew, product_detail, store });
    return makePurchaseInfoHtmlNess({ plus_crew, product_detail, store });
  }

  const now = Date.now();

  // TODO: 2025 설날배송 일정 변경 하드코딩 (https://www.notion.so/marpple/3cafd1c489674f8a928b17832d9df529)
  const is_2025_seolnal_step1 =
    now > utcToZonedTime('2025-01-21 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-01-27 00:00:00', UtilConstantS.TZ_SEOUL);

  const is_2025_seolnal_step2 =
    now > utcToZonedTime('2025-01-27 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-02-03 00:00:00', UtilConstantS.TZ_SEOUL);

  const is_2025_seolnal_step3 =
    now > utcToZonedTime('2025-02-03 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-02-10 00:00:00', UtilConstantS.TZ_SEOUL);

  const seolnal_deliver_dates = {
    start: [
      utcToZonedTime('2025-02-05 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-06 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-14 00:00:00', UtilConstantS.TZ_SEOUL),
    ],
    end: [
      utcToZonedTime('2025-02-12 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-13 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-19 00:00:00', UtilConstantS.TZ_SEOUL),
    ],
  };

  const transformAtSeolnal = (transformed_dates) => (date) => {
    if (is_2025_seolnal_step3) {
      return transformed_dates[2];
    } else if (is_2025_seolnal_step2) {
      return transformed_dates[1];
    } else if (is_2025_seolnal_step1) {
      return transformed_dates[0];
    } else {
      return date;
    }
  };

  const {
    _: { stores_product },
    stores_delivery_company,
    mpsShippingDays,
  } = product_detail;

  // --- chuseok hardcode end

  const isSaesonOnTshirt = () => sel('_.stores_product.product_id', product_detail) == 7053483;
  const addIfSeasonOn = ifElse(isSaesonOnTshirt, () => new Date('2021-03-17'), identity);
  const deliver_date = go(
    mpsShippingDays.minShippingDay,
    addIfSeasonOn,
    transformAtSeolnal(seolnal_deliver_dates.start),
  );
  const deliver_until_date = go(
    mpsShippingDays.maxShippingDay,
    transformAtSeolnal(seolnal_deliver_dates.end),
  );
  const date_format = T(messages.format.short_date);

  const is_nbox = UtilS.isNboxApp();

  const makeUrl = ({ type, hg_id }) => {
    return `/${T.lang}/@/help?type=${type}&hg_id=${hg_id}`;
  };

  return html`
    <div class="pd-purchase-info">
      <h3 class="pd-purchase-info__title">${ET('product_detail::tab03')}</h3>

      <!--  배송안내  -->
      <div class="pd-purchase-info__section">
        <div class="pd-purchase-info__header">
          <h4>${ET('product_detail::purchase_info::delivery_info')}</h4>
          <div class="arrow">${MShopCoreTmplS.arrowDownIcon()}</div>
        </div>
        <div class="pd-purchase-info__body">
          <div class="pd-purchase-info__body--inner">
            ${stores_product?.shipping_date_hidden
              ? ''
              : html`
                  <div class="pd-purchase-info__body__desc">
                    <p>
                      ${ET('product_detail::purchase_info::delivery_desc_mps', {
                        start: format(deliver_date, date_format),
                        end: format(deliver_until_date, date_format),
                        color: MShopCoreConstantS.colors.blue,
                      })}
                    </p>
                  </div>
                `}

            <!--  배송비 테이블  -->
            ${makeDeliveryInfoTable_POD_TPL({ stores_delivery_company })}

            <!--  링크 버튼  -->
            <div class="pd-purchase-info__links pd-links">
              <a
                href="${makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getShippingHgId({ is_nbox }),
                })}"
                class="pd-links__item"
                data-post-message="${$dataStr({
                  screen: {
                    title: `FAQ`,
                    type: 'sub',
                    uri: makeUrl({
                      domain: store?.domain_name,
                      type: getFqaType({ is_nbox }),
                      hg_id: getShippingHgId({ is_nbox }),
                    }),
                  },
                })}"
              >
                ${ET('product_detail::purchase_info::delivery_faq_btn')}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="pd-purchase-info__divider"></div>

      <!--  교환/환불  -->
      <div class="pd-purchase-info__section">
        <div class="pd-purchase-info__header">
          <h4>${ET('product_detail::purchase_info::exchange_info')}</h4>
          <div class="arrow">${MShopCoreTmplS.arrowDownIcon()}</div>
        </div>
        <div class="pd-purchase-info__body">
          <div class="pd-purchase-info__body--inner">
            <div class="pd-purchase-info__body__desc">
              <p>
                ${ET('product_detail::purchase_info::exchange_desc_mps', {
                  color: MShopCoreConstantS.colors.blue,
                })}
              </p>
            </div>
            <table class="pd-purchase-info__table">
              <tr>
                <th>${ET('product_detail::purchase_info::th_12')}</th>
                <td>
                  ${ET('product_detail::purchase_info::exchange_tel', {
                    tel: MShopUtilS.getCustomerServiceInfo(plus_crew.id).tel,
                  })}
                </td>
              </tr>
              <tr>
                <th>${ET('product_detail::purchase_info::th_4')}</th>
                <td>
                  ${ET('product_detail::purchase_info::exchange_email', {
                    email: MShopUtilS.getCustomerServiceInfo(plus_crew.id).email,
                  })}
                </td>
              </tr>
            </table>
            ${takeBackInfo(stores_delivery_company)}
            <div class="pd-purchase-info__anchor">
              <a class="anc_retraction_guide">
                ${MShopCoreTmplS.refundIcon()}
                ${ET('product_detail::purchase_info::exchange_widerrufsrecht_btn')}
                ${MShopCoreTmplS.chevronRightSmall()}
              </a>
              <a class="quality_guide">
                ${MShopCoreTmplS.guaranteeIcon()}
                ${ET('product_detail::purchase_info::exchange_guarantee_btn')}
                ${MShopCoreTmplS.chevronRightSmall()}
              </a>
            </div>
            <div class="pd-purchase-info__links pd-links">
              <a
                href="mailto:${MShopUtilS.getCustomerServiceInfo(plus_crew.id).email}"
                class="pd-links__item"
              >
                <span>${ET('product_detail::purchase_info::mps_qna_btn')}</span>
              </a>
              <a
                href="${makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getRefundHgId({ is_nbox }),
                })}"
                class="pd-links__item"
                data-post-message="${$dataStr({
                  screen: {
                    title: `FAQ`,
                    type: 'sub',
                    uri: makeUrl({
                      domain: store?.domain_name,
                      type: getFqaType({ is_nbox }),
                      hg_id: getRefundHgId({ is_nbox }),
                    }),
                  },
                })}"
              >
                ${ET('product_detail::purchase_info::exchange_faq_btn')}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="pd-purchase-info__divider"></div>

      <!--  신고안내  -->
      <div class="pd-purchase-info__section">
        <div class="pd-purchase-info__header">
          <h4>${ET('product_detail::purchase_info::report_info')}</h4>
          <div class="arrow">${MShopCoreTmplS.arrowDownIcon()}</div>
        </div>
        <div class="pd-purchase-info__body">
          <div class="pd-purchase-info__body--inner">
            <div class="pd-purchase-info__body__desc">
              <p>${ET('product_detail::purchase_info::report_desc')}</p>
            </div>
            <div class="pd-purchase-info__anchor">
              <a
                href="/${ET.lang}/@/solution/add?product_id=${product_detail.id}"
                data-post-message="${$dataStr(
                  makeEmptyScreenNavigate(`/${ET.lang}/@/solution/add?product_id=${product_detail.id}`),
                )}"
                class="product_report_btn"
              >
                ${MShopCoreTmplS.reportIcon()} ${ET('product_detail::purchase_info::report_btn')}
                ${MShopCoreTmplS.chevronRightSmall()}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="pd-purchase-info__divider"></div>
    </div>
  `;
};

const makePurchaseInfoHtmlNess = ({ plus_crew, product_detail, store }) => {
  const now = Date.now();

  // TODO: 2025 설날배송 일정 변경 하드코딩 (https://www.notion.so/marpple/3cafd1c489674f8a928b17832d9df529)
  const is_2025_seolnal_step1 =
    now > utcToZonedTime('2025-01-21 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-01-27 00:00:00', UtilConstantS.TZ_SEOUL);

  const is_2025_seolnal_step2 =
    now > utcToZonedTime('2025-01-27 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-02-03 00:00:00', UtilConstantS.TZ_SEOUL);

  const is_2025_seolnal_step3 =
    now > utcToZonedTime('2025-02-03 00:00:00', UtilConstantS.TZ_SEOUL) &&
    now < utcToZonedTime('2025-02-10 00:00:00', UtilConstantS.TZ_SEOUL);

  const seolnal_deliver_dates = {
    start: [
      utcToZonedTime('2025-02-05 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-06 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-14 00:00:00', UtilConstantS.TZ_SEOUL),
    ],
    end: [
      utcToZonedTime('2025-02-12 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-13 00:00:00', UtilConstantS.TZ_SEOUL),
      utcToZonedTime('2025-02-19 00:00:00', UtilConstantS.TZ_SEOUL),
    ],
  };

  const transformAtSeolnal = (transformed_dates) => (date) => {
    if (is_2025_seolnal_step3) {
      return transformed_dates[2];
    } else if (is_2025_seolnal_step2) {
      return transformed_dates[1];
    } else if (is_2025_seolnal_step1) {
      return transformed_dates[0];
    } else {
      return date;
    }
  };

  const {
    _: { stores_product },
    stores_delivery_company,
  } = product_detail;

  // --- seolnal hardcode end

  const isSaesonOnTshirt = () => sel('_.stores_product.product_id', product_detail) == 7053483;
  const addIfSeasonOn = ifElse(isSaesonOnTshirt, () => new Date('2021-03-17'), identity);
  const deliver_date = go(
    now,
    UtilS.getSalesPeriodOf,
    sel('sell_end_at'),
    addDays(3),
    addIfSeasonOn,
    transformAtSeolnal(seolnal_deliver_dates.start),
  );
  const deliver_until_date = go(addDays(7)(deliver_date), transformAtSeolnal(seolnal_deliver_dates.end));
  const date_format = T(messages.format.short_date);

  const is_nbox = UtilS.isNboxApp();

  const makeUrl = ({ domain, type, hg_id }) => {
    return `/${T.lang}/${domain}/help?type=${type}&hg_id=${hg_id}`;
  };

  return html`
    <div class="pd-purchase-info">
      <div class="pd-purchase-info__section">
        <!--  배송안내 타이틀  -->
        <div class="pd-purchase-info__header">
          <h4>${T(messages.purchaseInfo.delivery_title)}</h4>
        </div>
        ${stores_product?.shipping_date_hidden
          ? ''
          : html`
              <div class="pd-purchase-info__body__desc">
                <p>
                  ${ET('product_detail::purchase_delivery::pd02')}<br />
                  ${ET('product_detail::purchase_delivery::pd01', {
                    start: format(deliver_date, date_format),
                    end: format(deliver_until_date, date_format),
                    color: NessCoreConstantS.colors.blue,
                  })}
                </p>
              </div>
            `}
        <!--  배송비 테이블  -->
        ${storesDeliveryCompanyInfo({ stores_delivery_company, stores_product })}
        <!--  링크 버튼  -->
        <div class="pd-purchase-info__links pd-links">
          <a
            href="${makeUrl({
              domain: store?.domain_name,
              type: getFqaType({ is_nbox }),
              hg_id: getShippingHgId({ is_nbox }),
            })}"
            class="pd-links__item"
            data-post-message="${$dataStr({
              screen: {
                title: `FAQ`,
                type: 'sub',
                uri: makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getShippingHgId({ is_nbox }),
                }),
              },
            })}"
            >${ET('product_detail::link_delivery')}</a
          >
        </div>
      </div>
      <div class="pd-purchase-info__divider"></div>

      <!--  교환/환불  -->
      <div class="pd-purchase-info__section">
        <div class="pd-purchase-info__header">
          <h4>${T(messages.purchaseInfo.refund_title)}</h4>
        </div>
        <div class="pd-purchase-info__body__desc">
          <p>${ET('product_detail::purchase_delivery::info::c_01')}</p>
          <p>${ET('product_detail::purchase_delivery::info::01')}</p>
          <p>${ET('product_detail::purchase_delivery::info::02')}</p>
          <p>${ET('product_detail::purchase_delivery::info::03')}</p>
          <p>${ET('product_detail::purchase_delivery::info::04')}</p>
        </div>
        <div class="pd-purchase-info__body__desc">
          <h4>${ET('product_detail::purchase_delivery::case::title')}</h4>
          <ul>
            <li>${ET('product_detail::purchase_delivery::case::01')}</li>
            <li>${ET('product_detail::purchase_delivery::case::02')}</li>
            <li>${ET('product_detail::purchase_delivery::case::03')}</li>
            <li>${ET('product_detail::purchase_delivery::case::04')}</li>
            <li>${ET('product_detail::purchase_delivery::case::05')}</li>
            <li>${ET('product_detail::purchase_delivery::case::06')}</li>
            <li>${ET('product_detail::purchase_delivery::case::07')}</li>
          </ul>
        </div>
        <div class="pd-purchase-info__body">
          <table>
            <tr>
              <th>${T(messages.purchaseInfo.cs_title)}</th>
              <td>${MShopUtilS.getCustomerServiceInfo(plus_crew.id).tel}</td>
            </tr>
            <tr>
              <th>${T(messages.purchaseInfo.email_title)}</th>
              <td>${MShopUtilS.getCustomerServiceInfo(plus_crew.id).email}</td>
            </tr>
          </table>
        </div>
        <div class="pd-purchase-info__links pd-links">
          <a href="mailto:${MShopUtilS.getCustomerServiceInfo(plus_crew.id).email}" class="pd-links__item">
            <span>${ET('product_detail::link_chat')}</span>
          </a>
          <a
            href="${makeUrl({
              domain: store?.domain_name,
              type: getFqaType({ is_nbox }),
              hg_id: getRefundHgId({ is_nbox }),
            })}"
            class="pd-links__item"
            data-post-message="${$dataStr({
              screen: {
                title: `FAQ`,
                type: 'sub',
                uri: makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getRefundHgId({ is_nbox }),
                }),
              },
            })}"
            >${ET('product_detail::link_change')}</a
          >
        </div>
      </div>
      ${takeBackInfo(stores_delivery_company)}
      <div class="pd-purchase-info__divider"></div>
      <div class="pd-purchase-info__anchor">
        <a class="anc_retraction_guide">
          ${MShopUtilConstantS.svg.limit} ${T(messages.purchaseInfo.btn_guide1)}
        </a>
      </div>
      <div class="pd-purchase-info__anchor">
        <a class="quality_guide">
          ${MShopUtilConstantS.svg.quality} ${T(messages.purchaseInfo.btn_guide2)}
        </a>
      </div>
      <div class="pd-purchase-info__divider"></div>
    </div>
  `;
};

const makePurchaseInfoHtmlNessForAssetOrUser = ({ plus_crew, product_detail, store }) => {
  const {
    _: { stores_product },
    stores_delivery_company,
  } = product_detail;

  // --- seolnal hardcode end

  const is_nbox = UtilS.isNboxApp();

  const makeUrl = ({ domain, type, hg_id }) => {
    return `/${T.lang}/${domain}/help?type=${type}&hg_id=${hg_id}`;
  };

  return html`
    <div class="pd-purchase-info">
      <div class="pd-purchase-info__section">
        <!--  배송안내 타이틀  -->
        <div class="pd-purchase-info__header">
          <h4>${T(messages.purchaseInfo.delivery_title)}</h4>
        </div>
        ${stores_product?.shipping_date_hidden
          ? ''
          : html`
              <div class="pd-purchase-info__body__desc">
                <p>${ET('product_detail::purchase_delivery::pd02')}<br /></p>
              </div>
            `}
        <!--  배송비 테이블  -->
        ${storesDeliveryCompanyInfo({ stores_delivery_company, stores_product })}
        <!--  링크 버튼  -->
        <div class="pd-purchase-info__links pd-links">
          <a
            href="${makeUrl({
              domain: store?.domain_name,
              type: getFqaType({ is_nbox }),
              hg_id: getShippingHgId({ is_nbox }),
            })}"
            class="pd-links__item"
            data-post-message="${$dataStr({
              screen: {
                title: `FAQ`,
                type: 'sub',
                uri: makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getShippingHgId({ is_nbox }),
                }),
              },
            })}"
            >${ET('product_detail::link_delivery')}</a
          >
        </div>
      </div>
      <div class="pd-purchase-info__divider"></div>

      <!--  교환/환불  -->
      <div class="pd-purchase-info__section">
        <div class="pd-purchase-info__header">
          <h4>${T(messages.purchaseInfo.refund_title)}</h4>
        </div>
        <div class="pd-purchase-info__body__desc">
          <p>${ET('product_detail::purchase_delivery::info::b_01')}</p>
          <p>&nbsp;</p>
          <p>${ET('product_detail::purchase_delivery::info::01')}</p>
          <p>${ET('product_detail::purchase_delivery::info::02')}</p>
          <p>${ET('product_detail::purchase_delivery::info::03')}</p>
          <p>${ET('product_detail::purchase_delivery::info::04')}</p>
        </div>
        <div class="pd-purchase-info__body__desc">
          <h4>${ET('product_detail::purchase_delivery::case::title')}</h4>
          <ul>
            <li>${ET('product_detail::purchase_delivery::case::01')}</li>
            <li>${ET('product_detail::purchase_delivery::case::02')}</li>
            <li>${ET('product_detail::purchase_delivery::case::03')}</li>
            <li>${ET('product_detail::purchase_delivery::case::04')}</li>
            <li>${ET('product_detail::purchase_delivery::case::05')}</li>
            <li>${ET('product_detail::purchase_delivery::case::06')}</li>
            <li>${ET('product_detail::purchase_delivery::case::07')}</li>
          </ul>
        </div>
        <div class="pd-purchase-info__body">
          <table>
            <tr>
              <th>${T(messages.purchaseInfo.cs_title)}</th>
              <td>${MShopUtilS.getCustomerServiceInfo(plus_crew.id).tel}</td>
            </tr>
            <tr>
              <th>${T(messages.purchaseInfo.email_title)}</th>
              <td>${MShopUtilS.getCustomerServiceInfo(plus_crew.id).email}</td>
            </tr>
          </table>
        </div>
        <div class="pd-purchase-info__links pd-links">
          <a href="mailto:${MShopUtilS.getCustomerServiceInfo(plus_crew.id).email}" class="pd-links__item">
            <span>${ET('product_detail::link_chat')}</span>
          </a>
          <a
            href="${makeUrl({
              domain: store?.domain_name,
              type: getFqaType({ is_nbox }),
              hg_id: getRefundHgId({ is_nbox }),
            })}"
            class="pd-links__item"
            data-post-message="${$dataStr({
              screen: {
                title: `FAQ`,
                type: 'sub',
                uri: makeUrl({
                  domain: store?.domain_name,
                  type: getFqaType({ is_nbox }),
                  hg_id: getRefundHgId({ is_nbox }),
                }),
              },
            })}"
            >${ET('product_detail::link_change')}</a
          >
        </div>
      </div>
      ${takeBackInfo(stores_delivery_company)}
      <div class="pd-purchase-info__divider"></div>
      <div class="pd-purchase-info__anchor">
        <a class="anc_retraction_guide">
          ${MShopUtilConstantS.svg.limit} ${T(messages.purchaseInfo.btn_guide1)}
        </a>
      </div>
      <div class="pd-purchase-info__anchor">
        <a class="quality_guide">
          ${MShopUtilConstantS.svg.quality} ${T(messages.purchaseInfo.btn_guide2)}
        </a>
      </div>
      <div class="pd-purchase-info__divider"></div>
    </div>
  `;
};
